import React from 'react';

const OverviewTab = ({ course }) => {
  return (
    <div className="space-y-6">
      {course.objectives && course.objectives.length > 0 && (
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-4">What students will learn</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {course.objectives.map((objective, index) => (
              <div key={index} className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-gray-700 break-words overflow-hidden">{objective}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {course.requirements && course.requirements.length > 0 && (
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-4">Requirements</h3>
          <ul className="space-y-2 text-gray-700">
            {course.requirements.map((req, index) => (
              <li key={index} className="flex items-start">
                <span className="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="break-words overflow-hidden">{req}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {course.audiences && course.audiences.length > 0 && (
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-4">Who this course is for</h3>
          <ul className="space-y-2 text-gray-700">
            {course.audiences.map((audience, index) => (
              <li key={index} className="flex items-start">
                <span className="w-2 h-2 bg-gray-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span className="break-words overflow-hidden">{audience}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default OverviewTab;